<script>
    import {onMount} from "svelte";

    export let placeholder;
    export let inputId;
    export let readOnly = false;
    export let store;
    export let type;
    export let mask;
    export let max;
    export let min;
    export let required;
    import MaskInput from 'svelte-input-mask/MaskInput.svelte';
    import {focusMe} from '../directives/focusMe'

    let selfUpdate = false;
    let input;
    let inputElem;
    let value;

    onMount(() => {
        if (type) input.type = type;
        if (readOnly) input.setAttribute("readonly", "true");
        if (inputId) input.id = inputId;
        inputElem = document.getElementById(inputId);
        if(!!mask) inputElem.focus();
    });

    store.subscribe(v => value = v)

</script>

<style>
    input {
        max-width: calc(100% - 24px);
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid white;
        box-sizing: border-box;
        border-radius: 8px;
        color: white;
        height: 56px;
        outline: none;
        text-align: center;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
        width: 460px;
        margin-top: 12px;
        margin-bottom: 12px;
    }
</style>
{#if !mask}
    <input use:focusMe bind:value={value} on:input={(v) => $store = v.target.value} bind:this={input}/>
{/if}

{#if !!mask}
    <MaskInput style="max-width: calc(100vw - 24px);
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid white;
        box-sizing: border-box;
        border-radius: 8px;
        color: white;
        height: 56px;
        outline: none;
        text-align: center;
        width: 460px;
        margin-top: 12px;
        margin-bottom: 12px;"
              bind:this={input}
               id={inputId}
               {mask}
               placeholder={placeholder}
               required={required}
               on:change={(v) => $store = v.detail.inputState.unmaskedValue}/>
{/if}
